























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import ListUtils from '@/lib/listUtils';
import ConversationStatus from '@/components/Conversations/Display/ConversationStatus.vue'
import { MessagingModule } from '@/store/modules/messaging';
import EntityType from '@/models/Shared/EntityType';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';

@Component({
    name: 'ConversationListSearchCriteria',
    components: { ConversationStatus }

})
export default class extends GiganautVueDialog {
 
  public dialog = false;

  @Prop({required: true})
  entityType: EntityType;
  
	@Prop({required: true})
  showSelected: boolean;
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      if (AgencySettingsModule.agencyUsers) {
        AgencySettingsModule.getAgencyUsers();
      }
    }
  }

  get searchOptions() {
    if (this.entityType === EntityType.Worker) {
          return WorkerDetailsModule.filterConversationSearchViewModel;
    }
    return MessagingModule.filterConversationSearchViewModel;
  
  }

  get currentSearchCriteria() {
    if (this.entityType === EntityType.Worker) {
      return WorkerDetailsModule.currentConversationSearchCriteria;
    }
    return MessagingModule.currentConversationSearchCriteria;
  }

  get agencyUsers() {
    return AgencySettingsModule.agencyUsers;
  }

  get statusOptions() {
    return ListUtils.conversationStatuses();
  }

  get loading() {
    if (this.entityType === EntityType.Worker) {
      return WorkerDetailsModule.loadingConversations;
    }
    return MessagingModule.loadingConversations;
  }

  async search() {
    this.dialog = false;
    if (this.entityType === EntityType.Worker) {
      await WorkerDetailsModule.getConversations(0);
    } else {
      await MessagingModule.getConversations(0);
    }
  }
}
